import * as React from 'react';
import { SVGProps } from 'react';

const SvgAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="m21 9.23-2.048-3.46-4.904 2.77V3H9.952v5.54L5.048 5.77 3 9.23 7.904 12 3 14.77l2.048 3.46 4.904-2.77V21h4.096v-5.54l4.904 2.77L21 14.77 16.095 12 21 9.23z" />
  </svg>
);

export default SvgAlert;
